import { t } from 'i18next'
import DOMPurify from 'dompurify'

interface Replacement {
  key: string
  value: string
}

export const translation = (translationKey: string, replacements?: Replacement[]): string => {
  let translation = t(translationKey)

  if (!replacements) return translation

  replacements.forEach(({ key, value }) => {
    const placeholder = `%${key}%`
    translation = translation.replace(new RegExp(placeholder, 'g'), value)
  })

  // Sanitize the translation to prevent XSS attacks
  translation = DOMPurify.sanitize(translation)

  return translation
}
